import React, { useState } from 'react';
import { SectionHeader } from './SectionHeader';
import { ChevronDown, Calendar, ListChecks, Clock, BrainCircuit } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const bonos = [{
  num: 1,
  icon: Calendar,
  title: 'Planificador de parciales',
  subtitle: 'Organizate en 10 minutos y estudiá con dirección',
  bullets: ['Inventario de materias, sistema de prioridades y grilla semanal completable', 'Tracker de progreso para saber exactamente cómo vas semana a semana', 'Listo para imprimir o completar en digital']
}, {
  num: 2,
  icon: ListChecks,
  title: 'Checklist del examen',
  subtitle: 'La noche anterior y la mañana del día D, sin improvisar nada',
  bullets: ['Checklist completo de la noche anterior y la mañana del examen', 'Qué hacer si te levantás con pánico el día del examen', 'Página para llevar en el bolsillo el día que rendís']
}, {
  num: 3,
  icon: Clock,
  title: 'Guía de emergencia 48 horas',
  subtitle: 'El plan de acción cuando el tiempo ya no alcanza',
  bullets: ['Cronograma hora por hora para 48 y 24 horas antes del examen', 'Técnicas de repaso ultrarrápido sin perder lo esencial', 'El criterio exacto para saber qué estudiar primero cuando el tiempo se acaba']
}, {
  num: 4,
  icon: BrainCircuit,
  title: 'Frases y recursos mentales',
  subtitle: 'Herramientas psicológicas para los momentos más difíciles',
  bullets: ['30 frases de anclaje para antes, durante y después del examen', 'Técnica de visualización de 5 minutos y protocolo de reencuadre del miedo', 'Tarjeta de bolsillo para llevar el día del examen']
}];
export function Bonos() {
  const [openId, setOpenId] = useState<number | null>(null);
  return <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-2">
      <div className="max-w-[800px] mx-auto" data-id="element-3">
        <SectionHeader data-id="element-4" />
        <div className="text-center mb-12" data-id="element-5">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-6">
            INCLUIDOS GRATIS
          </h2>
          <p className="text-xl text-dark/70 font-medium mb-4" data-id="element-7">
            4 Bonos Estratégicos
          </p>
          <p className="text-sm font-medium text-dark/60 bg-cream inline-block px-4 py-2 rounded-full border border-border" data-id="element-8">
            Sin costo extra — incluidos en el Pack Esencial y el Pack Total
          </p>
        </div>

        <div className="space-y-3 md:space-y-4 mb-10" data-id="element-9">
          {bonos.map(bono => <div key={bono.num} className={`bg-cream rounded-xl md:rounded-2xl border transition-all duration-300 overflow-hidden ${openId === bono.num ? 'border-palegreen shadow-md' : 'border-border shadow-sm hover:border-palegreen/50'}`} data-id="element-10">
              <button onClick={() => setOpenId(openId === bono.num ? null : bono.num)} className="w-full text-left px-4 py-3 md:px-6 md:py-5 flex items-center justify-between focus:outline-none group" data-id="element-11">
                <div className="flex items-center gap-3 md:gap-4" data-id="element-12">
                  <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center font-bold transition-colors ${openId === bono.num ? 'bg-palegreen text-green-800' : 'bg-white text-dark/50 group-hover:bg-palegreen/30'}`} data-id="element-13">
                    <bono.icon size={20} className="md:w-6 md:h-6" data-id="element-14" />
                  </div>
                  <div data-id="element-15">
                    <div className="flex items-center gap-2 mb-0.5 md:mb-1" data-id="element-16">
                      <p className="text-[10px] md:text-xs font-bold text-dark/50 uppercase tracking-wider" data-id="element-17">
                        BONO {bono.num}
                      </p>
                      <span className="bg-green-100 text-green-800 text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-18">
                        Gratis
                      </span>
                    </div>
                    <h3 className="font-bold text-sm md:text-lg lg:text-xl leading-tight" data-id="element-19">
                      {bono.title}
                    </h3>
                  </div>
                </div>
                <motion.div animate={{
              rotate: openId === bono.num ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-20">
                  <ChevronDown className={`shrink-0 ${openId === bono.num ? 'text-green-600' : 'text-dark/40'}`} size={20} data-id="element-21" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-22">
                {openId === bono.num && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-23">
                    <div className="px-4 pb-4 pt-1 md:px-6 md:pb-6 md:pt-2 border-t border-border/50" data-id="element-24">
                      <p className="font-medium text-dark/80 mb-3 md:mb-4 italic text-xs md:text-base" data-id="element-25">
                        "{bono.subtitle}"
                      </p>
                      <ul className="space-y-2 md:space-y-3" data-id="element-26">
                        {bono.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 md:gap-3 text-xs md:text-base" data-id="element-27">
                            <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-1.5 md:mt-2 shrink-0" data-id="element-28" />
                            <span className="text-dark/80" data-id="element-29">{bullet}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center" data-id="element-30">
          <p className="text-lg font-bold bg-palegreen/40 inline-block px-8 py-4 rounded-xl border border-palegreen" data-id="element-31">
            VALOR TOTAL DE LOS BONOS:{' '}
            <span className="line-through text-dark/50 mr-2" data-id="element-32">$15.000</span>{' '}
            GRATIS
          </p>
        </div>
      </div>
    </section>;
}